/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateBrandMutationRequest,
  UpdateBrandMutationResponse,
  UpdateBrandPathParams,
  UpdateBrand400,
  UpdateBrand404,
} from '../types/UpdateBrand'

function getUpdateBrandUrl({ id }: { id: UpdateBrandPathParams['id'] }) {
  const res = {
    method: 'PUT',
    url: `/api/v1/products/catalog/brands/${id}/` as const,
  }
  return res
}

/**
 * @description Update an existing brand.
 * @summary Update a brand
 * {@link /api/v1/products/catalog/brands/:id/}
 */
export async function updateBrand(
  { id }: { id: UpdateBrandPathParams['id'] },
  data: UpdateBrandMutationRequest,
  config: Partial<RequestConfig<UpdateBrandMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateBrandMutationResponse,
    ResponseErrorConfig<UpdateBrand400 | UpdateBrand404>,
    UpdateBrandMutationRequest
  >({
    method: 'PUT',
    url: getUpdateBrandUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
